export default {"src":"https://s.sylndr.com/c-0d6ce1e/_next/static/media/carousel_arrow_left.5d81a27b.svg","height":45,"width":44,"blurWidth":0,"blurHeight":0};